module.exports = __webpack_public_path__ + "static/img/02_03.5237ad4a.jpg";